import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteBankAccountSaga,
  getBankAccountDetailsSaga,
  getBankAccountSaga,
} from "src/store/bankaccounts/saga";
import { BankAccountDto } from "src/store/bankaccounts/type";
import BankAccountCreateForm from "./create";
import BankAccountEditForm from "./edit";
const BankAccountPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<BankAccountDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<BankAccountDto>();
  const columns = [
    {
      text: t("BankAccount.BankName"),
      dataField: "BankName",
    },
    {
      text: t("BankAccount.OwnerName"),
      dataField: "OwnerName",
    },
    {
      text: t("BankAccount.AccountNumber"),
      dataField: "AccountNumber",
    },
    {
      text: t("BankAccount.Iban"),
      dataField: "Iban",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("BankAccount.PageTitle")}
        metaTag={t("BankAccount.MetaTag")}
        gridProps={{
          addTitle: t("BankAccount.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getBankAccountSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getBankAccountDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      setSelected(payload);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: BankAccountDto) =>
              t("BankAccount.DeleteQA", {
                name: data.BankName,
              }),
            action: deleteBankAccountSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <BankAccountCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getBankAccountSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <BankAccountEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getBankAccountSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default BankAccountPage;
